import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Page } from '@core/services/auth/auth.model';
import { AuthService } from '@core/services/auth/auth.service';

@Component({
  selector: 'Teranet-LandingPage',
  templateUrl: './landing-page.component.html',
})
export class LandingPageComponent implements OnInit {
  types: any[];
  currentPages: Page[];

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.getPages();
  }

  getPages() {
    this.types = [];
    if (this.authService.Isauthenticated) {
      this.currentPages = this.authService.currentUserValue.pages.filter(
        x =>
          x.route == 'lookup' ||
          x.route == 'workqueue' ||
          x.route == 'downloadreport' ||
          x.route == 'user' ||
          x.route == 'downloadinputfile' ||
          x.route == 'fileprocessing' ||
          x.displayName == 'Daily Monitoring'
      );

      for (let index = 0; index < this.currentPages.length; index++) {
        var element = this.currentPages[index];
        element.modelName = element.route;
        if (element.route == 'workqueue') {
          element.iconName = 'folder-open';
          element.order = 0;
        } else if (element.displayName == 'Daily Monitoring') {
          element.iconName = 'calendar';
          element.modelName = 'workqueue';
          element.order = 1;
        } else if (element.route == 'lookup') {
          element.iconName = 'search';
          element.displayName = 'Lookup by Account Number or Policy Number';
          element.order = 2;
        } else if (element.route == 'downloadreport') {
          element.iconName = 'file';
          element.displayName = 'Generate Reports';
          element.order = 3;
        } else if (element.route == 'downloadinputfile') {
          element.iconName = 'download';
          element.displayName = 'Download Source Files';
          element.order = 4;
        } else if (element.route == 'fileprocessing') {
          element.iconName = 'upload';
          element.displayName = 'File Processing';
          element.order = 5;
        } else if (element.route == 'user') {
          element.iconName = 'user';
          element.displayName = 'Manage Users';
          element.order = 6;
        } else {
          continue;
        }

        this.types.push({
          label: element.displayName,
          value: element.modelName,
          icon: element.iconName,
          order: element.order,
        });
        this.types = this.types.sort((a, b) => (a.order > b.order ? 1 : -1));
      }
    }
  }

  routerLink(type: any): void {
    if (type.label == 'Daily Monitoring') {
      this.router.navigate([type.value], { queryParams: { from: 'main', queuetype: '5' } });
    } else {
      this.router.navigate([type.value]);
    }
  }
}
